import React, {useState} from 'react'
import {Button, Modal, Popconfirm, Table} from 'antd';

function BookShortPhoneModal(props) {
    const {showModal, handleBookNumber, toggleModal, listVirtualNumber, loading} = props
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRows)
        }
    };

    const columns = [
        {
            title: 'Phone',
            dataIndex: 'shortPhone',
            key: 'shortPhone',
        }
    ];

    const handleCancel = () => {
        toggleModal()
    }

    const onBookNumber = async () => {
        handleBookNumber(selectedRowKeys[0]?.shortPhone)
    }

    return <>
        <Modal
            title="Book số"
            className={`ModalCustom2`}
            style={{top: 20}}
            maskClosable={false}
            open={showModal}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Button onClick={onBookNumber} key="submit" type="primary" loading={loading}
                            disabled={selectedRowKeys.length === 0}>
                        Book số
                    </Button>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                </div>
            ]}
        >
            <div className="FormAddNew">
                {listVirtualNumber.length > 0 && (
                    <>
                        <div className="total mb-2 d-flex justify-content-end">{listVirtualNumber.length} items</div>
                        <Table
                            rowSelection={{
                                type: "radio",
                                ...rowSelection,
                            }}
                            columns={columns}
                            dataSource={listVirtualNumber}
                        />
                    </>
                )}
            </div>
        </Modal>
    </>
}

export default BookShortPhoneModal
